<template>
  <span>
    <b-tabs
      v-if="showFileUpload"
      v-model="tabIndex"
    >
      <b-tab :title="$t('Single Config')">
        <validation-observer ref="simpleRules">
          <b-form>

            <!-- Project Name -->
            <b-form-group
              label="Project Name"
              label-for="mc-project-name"
            >
              <validation-provider
                #default="{ errors }"
                name="Project Name"
                rules="required"
              >
                <b-form-input
                  v-model="item.projectName"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Project Name"
                />
                <small class="text-danger">{{ $t(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>

            <!-- Report Title -->
            <b-form-group
              label="Report Title"
              label-for="mc-report-title"
            >
              <validation-provider
                #default="{ errors }"
                name="Report Title"
                rules="required"
              >
                <b-form-input
                  v-model="item.reportTitle"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Report Title"
                />
                <small class="text-danger">{{ $t(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>

            <!-- Filter -->
            <b-form-group
              label="Filter"
              label-for="mc-filter"
            >
              <validation-provider
                #default="{ errors }"
                name="Filter"
                rules="required"
              >
                <b-form-textarea
                  v-model="item.filter"
                  :state="errors.length > 0 ? false:null"
                  rows="10"
                  placeholder="Filter"
                />
                <small class="text-danger">{{ $t(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>

            <!-- Column Names -->
            <b-form-group
              label="Column Names"
              label-for="mc-columnNames"
            >
              <validation-provider
                #default="{ errors }"
                name="Column Names"
                rules="required"
              >
                <b-form-textarea
                  v-model="item.columnNames"
                  :state="errors.length > 0 ? false:null"
                  rows="10"
                  placeholder="Column Names"
                />
                <small class="text-danger">{{ $t(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>

            <!-- Column Display Names -->
            <b-form-group
              label="Column Display Names"
              label-for="mc-columnDisplayNames"
            >
              <validation-provider
                #default="{ errors }"
                name="Column Display Names"
                rules="required"
              >
                <b-form-textarea
                  v-model="item.columnDisplayNames"
                  :state="errors.length > 0 ? false:null"
                  rows="10"
                  placeholder="Column Display Names"
                />
                <small class="text-danger">{{ $t(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>

            <!-- Tops -->
            <b-form-group
              label="Tops"
              label-for="mc-tops"
            >
              <validation-provider
                #default="{ errors }"
                name="Top N Values"
                rules="required"
              >
                <b-form-textarea
                  v-model="item.tops"
                  :state="errors.length > 0 ? false:null"
                  rows="5"
                  placeholder="2,2,3..."
                />
                <small class="text-danger">{{ $t(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>

            <!-- Bottoms -->
            <b-form-group
              label="Bottoms"
              label-for="mc-bottoms"
            >
              <validation-provider
                #default="{ errors }"
                name="Bottom N Values"
                rules="required"
              >
                <b-form-textarea
                  v-model="item.bottoms"
                  :state="errors.length > 0 ? false:null"
                  rows="5"
                  placeholder="2,2,3..."
                />
                <small class="text-danger">{{ $t(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>

            <!-- Notrs -->
            <b-form-group
              label="Notrs"
              label-for="mc-notrs"
            >
              <validation-provider
                #default="{ errors }"
                name="Show Notrs"
                rules="required"
              >
                <b-form-textarea
                  v-model="item.notrs"
                  :state="errors.length > 0 ? false:null"
                  rows="5"
                  placeholder="true,false,true..."
                />
                <small class="text-danger">{{ $t(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>

            <!-- Break By Question -->
            <b-form-group
              label="Break By Question"
              label-for="mc-break-by-question-name"
            >
              <validation-provider
                #default="{ errors }"
                name="Show Notrs"
                rules="required"
              >
                <b-form-input
                  v-model="item.breakByQuestionName"
                  placeholder="Break By..."
                  :state="errors.length > 0 ? false:null"
                />
                <small class="text-danger">{{ $t(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>

            <!-- Weight Column -->
            <b-form-group
              label="Weight Column"
              label-for="mc-weight-column"
            >
              <b-form-input
                v-model="item.weightColumn"
                placeholder="Weight Column"
              />
            </b-form-group>

            <!-- Loop Column -->
            <b-form-group
              label="Loop Column"
              label-for="mc-loop-column"
            >
              <b-form-input
                v-model="item.loopColumn"
                placeholder="Loop Column"
              />
            </b-form-group>

            <b-row>
              <!-- Sort Order -->
              <b-col>
                <b-form-group
                  label="Sort Order"
                  label-for="mc-sort-order"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Sort Order"
                    rules="required|between:0,99999"
                  >
                    <b-form-input
                      v-model="item.sortOrder"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Sort Order (0-99999)"
                    />
                    <small class="text-danger">{{ $t(errors[0]) }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Part"
                  label-for="mc-part"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Part"
                    rules="required"
                  >
                    <b-form-input
                      v-model="item.part"
                      :state="errors.length > 0 ? false:null"
                      placeholder="Part"
                    />
                    <small class="text-danger">{{ $t(errors[0]) }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <!-- Rolling -->
              <b-col>
                <b-form-group
                  :label="$t('Rolling')"
                  label-for="mc-rolling"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('Rolling')"
                    rules="required|between:1,12"
                  >
                    <b-form-input
                      v-model="item.rolling"
                      :state="errors.length > 0 ? false:null"
                      :placeholder="$t('Rolling (1-12)')"
                    />
                    <small class="text-danger">{{ $t(errors[0]) }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <!-- Decimal Place -->
              <b-col>
                <b-form-group
                  :label="$t('Decimal Places')"
                  label-for="mc-decimalPlace"
                >
                  <validation-provider
                    #default="{ errors }"
                    :name="$t('Decimal Places')"
                    rules="required|between:1,12"
                  >
                    <b-form-input
                      v-model="item.decimalPlace"
                      :state="errors.length > 0 ? false:null"
                      :placeholder="$t('Decimal Places')"
                    />
                    <small class="text-danger">{{ $t(errors[0]) }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- Cumulative / Year To Date-->
            <b-row>
              <b-col>
                <b-form-group
                  label="Show Cumulative?"
                  label-for="mc-showCumulative"
                >
                  <b-form-checkbox
                    id="mc-showCumulative"
                    v-model="item.showCumulative"
                    name="mc-showCumulative"
                    switch
                  >
                    <span v-if="item.showCumulative">{{ $t('Yes') }}</span>
                    <span v-if="!item.showCumulative">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Show Year To Date?"
                  label-for="mc-showYearToDate"
                >
                  <b-form-checkbox
                    id="mc-showYearToDate"
                    v-model="item.showYearToDate"
                    name="mc-showYearToDate"
                    switch
                  >
                    <span v-if="item.showYearToDate">{{ $t('Yes') }}</span>
                    <span v-if="!item.showYearToDate">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Show Unweighted Base?"
                  label-for="mc-showUnweightedBase"
                >
                  <b-form-checkbox
                    id="mc-showUnweightedBase"
                    v-model="item.showUnweightedBase"
                    name="mc-showUnweightedBase"
                    switch
                  >
                    <span v-if="item.showUnweightedBase">{{ $t('Yes') }}</span>
                    <span v-if="!item.showUnweightedBase">{{ $t('No') }}</span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- ScoreGroups -->
            <b-form-group
              label="Score Groups"
              label-for="mc-scoreGroups"
            >
              <validation-provider
                #default="{ errors }"
                name="Score Groups"
                rules="required"
              >
                <b-form-textarea
                  v-model="item.scoreGroups"
                  :state="errors.length > 0 ? false:null"
                  rows="10"
                  placeholder="Score Groups"
                />
                <small class="text-danger">{{ $t(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>

          </b-form>
        </validation-observer>
      </b-tab>
      <b-tab
        :title="$t('Multi Config')"
      >

        <p><b-link @click="downloadCurrent">Download Report Configs</b-link></p>
        <validation-observer ref="simpleRules2">
          <b-form>

            <!-- Report Config File -->
            <b-form-group
              label="Report Config File"
              label-for="report_config_file"
            >
              <b-form-file
                id="report_config_file"
                v-model="report_config_file"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
              />
            </b-form-group>

          </b-form>
        </validation-observer>

      </b-tab>

    </b-tabs>
    <validation-observer
      v-else
      ref="simpleRules"
    >
      <b-form>

        <!-- Project Name -->
        <b-form-group
          label="Project Name"
          label-for="mc-project-name"
        >
          <validation-provider
            #default="{ errors }"
            name="Project Name"
            rules="required"
          >
            <b-form-input
              v-model="item.projectName"
              :state="errors.length > 0 ? false:null"
              placeholder="Project Name"
            />
            <small class="text-danger">{{ $t(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Report Title -->
        <b-form-group
          label="Report Title"
          label-for="mc-report-title"
        >
          <validation-provider
            #default="{ errors }"
            name="Report Title"
            rules="required"
          >
            <b-form-input
              v-model="item.reportTitle"
              :state="errors.length > 0 ? false:null"
              placeholder="Report Title"
            />
            <small class="text-danger">{{ $t(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Filter -->
        <b-form-group
          label="Filter"
          label-for="mc-filter"
        >
          <validation-provider
            #default="{ errors }"
            name="Filter"
            rules="required"
          >
            <b-form-textarea
              v-model="item.filter"
              :state="errors.length > 0 ? false:null"
              rows="10"
              placeholder="Filter"
            />
            <small class="text-danger">{{ $t(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Column Names -->
        <b-form-group
          label="Column Names"
          label-for="mc-columnNames"
        >
          <validation-provider
            #default="{ errors }"
            name="Column Names"
            rules="required"
          >
            <b-form-textarea
              v-model="item.columnNames"
              :state="errors.length > 0 ? false:null"
              rows="10"
              placeholder="Column Names"
            />
            <small class="text-danger">{{ $t(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Column Display Names -->
        <b-form-group
          label="Column Display Names"
          label-for="mc-columnDisplayNames"
        >
          <validation-provider
            #default="{ errors }"
            name="Column Display Names"
            rules="required"
          >
            <b-form-textarea
              v-model="item.columnDisplayNames"
              :state="errors.length > 0 ? false:null"
              rows="10"
              placeholder="Column Display Names"
            />
            <small class="text-danger">{{ $t(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Tops -->
        <b-form-group
          label="Tops"
          label-for="mc-tops"
        >
          <validation-provider
            #default="{ errors }"
            name="Top N Values"
            rules="required"
          >
            <b-form-textarea
              v-model="item.tops"
              :state="errors.length > 0 ? false:null"
              rows="10"
              placeholder="2,2,3..."
            />
            <small class="text-danger">{{ $t(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Bottoms -->
        <b-form-group
          label="Bottoms"
          label-for="mc-bottoms"
        >
          <validation-provider
            #default="{ errors }"
            name="Bottom N Values"
            rules="required"
          >
            <b-form-textarea
              v-model="item.bottoms"
              :state="errors.length > 0 ? false:null"
              rows="10"
              placeholder="2,2,3..."
            />
            <small class="text-danger">{{ $t(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Notrs -->
        <b-form-group
          label="Notrs"
          label-for="mc-notrs"
        >
          <validation-provider
            #default="{ errors }"
            name="Show Notrs"
            rules="required"
          >
            <b-form-textarea
              v-model="item.notrs"
              :state="errors.length > 0 ? false:null"
              rows="10"
              placeholder="true,false,true..."
            />
            <small class="text-danger">{{ $t(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Break By Question -->
        <b-form-group
          label="Break By Question"
          label-for="mc-break-by-question-name"
        >
          <validation-provider
            #default="{ errors }"
            name="Show Notrs"
            rules="required"
          >
            <b-form-input
              v-model="item.breakByQuestionName"
              placeholder="Break By..."
              :state="errors.length > 0 ? false:null"
            />
            <small class="text-danger">{{ $t(errors[0]) }}</small>
          </validation-provider>
        </b-form-group>

        <!-- Weight Column -->
        <b-form-group
          label="Weight Column"
          label-for="mc-weight-column"
        >
          <b-form-input
            v-model="item.weightColumn"
            placeholder="Weight Column"
          />
        </b-form-group>

        <!-- Loop Column -->
        <b-form-group
          label="Loop Column"
          label-for="mc-loop-column"
        >
          <b-form-input
            v-model="item.loopColumn"
            placeholder="Loop Column"
          />
        </b-form-group>

        <b-row>
          <!-- Sort Order -->
          <b-col>
            <b-form-group
              label="Sort Order"
              label-for="mc-sort-order"
            >
              <validation-provider
                #default="{ errors }"
                name="Sort Order"
                rules="required|between:0,99999"
              >
                <b-form-input
                  v-model="item.sortOrder"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Sort Order (0-99999)"
                />
                <small class="text-danger">{{ $t(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Part -->
          <b-col>
            <b-form-group
              label="Part"
              label-for="mc-part"
            >
              <validation-provider
                #default="{ errors }"
                name="Part"
                rules="required|between:0,999"
              >
                <b-form-input
                  v-model="item.part"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Part (0-999)"
                />
                <small class="text-danger">{{ $t(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- Rolling -->
          <b-col>
            <b-form-group
              :label="$t('Rolling')"
              label-for="mc-rolling"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('Rolling')"
                rules="required|between:1,12"
              >
                <b-form-input
                  v-model="item.rolling"
                  :state="errors.length > 0 ? false:null"
                  :placeholder="$t('Rolling (1-12)')"
                />
                <small class="text-danger">{{ $t(errors[0]) }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Cumulative / Year To Date-->
        <b-row>
          <b-col>
            <b-form-group
              label="Show Cumulative?"
              label-for="mc-showCumulative"
            >
              <b-form-checkbox
                id="mc-showCumulative"
                v-model="item.showCumulative"
                name="mc-showCumulative"
                switch
              >
                <span v-if="item.showCumulative">{{ $t('Yes') }}</span>
                <span v-if="!item.showCumulative">{{ $t('No') }}</span>
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="Show Year To Date?"
              label-for="mc-showYearToDate"
            >
              <b-form-checkbox
                id="mc-showYearToDate"
                v-model="item.showYearToDate"
                name="mc-showYearToDate"
                switch
              >
                <span v-if="item.showYearToDate">{{ $t('Yes') }}</span>
                <span v-if="!item.showYearToDate">{{ $t('No') }}</span>
              </b-form-checkbox>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              label="Show Unweighted Base?"
              label-for="mc-showUnweightedBase"
            >
              <b-form-checkbox
                id="mc-showUnweightedBase"
                v-model="item.showUnweightedBase"
                name="mc-showUnweightedBase"
                switch
              >
                <span v-if="item.showUnweightedBase">{{ $t('Yes') }}</span>
                <span v-if="!item.showUnweightedBase">{{ $t('No') }}</span>
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>

      </b-form>
    </validation-observer>

  </span>

</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BFormGroup, BFormInput, BForm, BFormTextarea, BRow, BCol, BTabs, BTab, BFormFile, BLink, BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormInput,
    BForm,
    BFormTextarea,
    BRow,
    BCol,
    BTabs,
    BTab,
    BFormFile,
    BLink,
    BFormCheckbox,
  },
  props: {
    projectId: {
      type: [Number, String],
      required: true,
    },
    value: {
      type: Object,
      default: null,
    },
    showFileUpload: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tabIndex: 0,
      defaultItem: {
        projectName: null,
        reportTitle: null,
        filter: null,
        columnNames: null,
        tops: null,
        bottoms: null,
        notrs: null,
        columnDisplayNames: null,
        scoreGroups: null,
        weightColumn: null,
        loopColumn: null,
        breakByQuestionName: 'donem',
        rolling: 1,
        decimalPlace: 2,
        sortOrder: 0,
        part: 1,
        active: true,
        showCumulative: false,
        showYearToDate: true,
        showUnweightedBase: false,
      },
      required,
      report_config_file: null,
    }
  },
  computed: {
    item: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        if (this.value) {
          return this.value
        }
        return this.defaultItem
      },
    },
  },
  created() {
    this.item.projectId = this.projectId
  },
  methods: {
    openFile(response, filename) {
      const blob = new Blob([`\ufeff${response.data}`], {
        type: 'text/csv; charset=utf-8',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
      link.remove()
    },
    downloadCurrent() {
      useJwt.axiosIns.get('report/downloadCurrentConfigs', { params: { projectId: this.projectId } })
        .then(response => {
          if (response.data) {
            this.openFile(response, `reportConfig_${this.projectId}.csv`)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    validationForm() {
      if (this.tabIndex === 0) {
        this.$refs.simpleRules.validate().then(success => {
          if (success) {
            if (this.item.id) {
              useJwt.axiosIns.patch('report', this.item)
                .then(response => {
                  if (response.data) {
                    this.$emit('submit')
                  }
                })
                .catch(e => {
                  console.log(e)
                })
            } else {
              useJwt.axiosIns.post('report', this.item)
                .then(response => {
                  if (response.data) {
                    this.$emit('submit')
                  }
                })
                .catch(e => {
                  console.log(e)
                })
            }
          }
        })
      } else {
        this.$refs.simpleRules2.validate().then(success => {
          if (success && this.report_config_file) {
            const formData = new FormData()
            formData.append('ProjectId', this.projectId)
            formData.append('ReportConfigFile', this.report_config_file)

            useJwt.axiosIns.post('report/UploadFiles', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
              .then(response => {
                if (response.data) {
                  if (response.data === 'Ok') {
                    this.$emit('submit')
                  } else {
                    this.$emit('error', response.data)
                  }
                  this.report_config_file = null
                }
              })
              .catch(e => {
                console.log(e)
              })
          } else {
            this.$emit('error', 'Select a file!')
          }
        })
      }
    },
  },
}
</script>
